__turbopack_context__.v({
  "checkbox": "checkbox-module-scss-module__Ot6WEG__checkbox",
  "checkboxItem": "checkbox-module-scss-module__Ot6WEG__checkboxItem",
});
